import { Data } from '@angular/router'
import { FeatureGuard } from '@engineering11/config-web'
import { CnectFeature } from '../config'

export const featureOnOnlyGuard = (feature: CnectFeature) => ({ canActivate: [FeatureGuard], data: { feature } })

export const mergeRouteGuards = (...guards: Array<{ canActivate?: any[]; data?: Data }>) => {
  const merged: { canActivate?: any[]; data?: Data } = {}

  for (const guard of guards) {
    if (guard.canActivate) {
      merged.canActivate = [...(merged.canActivate || []), ...guard.canActivate]
    }

    if (guard.data) {
      merged.data = { ...(merged.data || {}), ...guard.data }
    }
  }

  return merged
}
